import APPLICATION_CONSTANTS from '../helper/application-conf';
import {
    useState,
    useEffect,
} from 'react';
import { StorageService } from '../helper/storage-service';
import { environmentService, Environment } from './environmentService';

const storage = new StorageService();
const environment = new environmentService();

export class HeaderFooterService {

    HeaderComponentURL() {
        const env = environment.getEnvironment();
        let headerURL = APPLICATION_CONSTANTS.AXP_HEADER_E3_URL
        if (env == Environment.Dev) {
            headerURL = APPLICATION_CONSTANTS.AXP_HEADER_E2_URL;
        }
        else if (env == Environment.Stage) {
            headerURL = APPLICATION_CONSTANTS.AXP_HEADER_E2_URL;
        }
        else {
            headerURL = APPLICATION_CONSTANTS.AXP_HEADER_E3_URL;
        }
        return headerURL;
    }

    FooterComponentURL() {
        const env = environment.getEnvironment();
        let footerURL = APPLICATION_CONSTANTS.AXP_FOOTER_E3_URL
        if (env == Environment.Dev) {
            footerURL = APPLICATION_CONSTANTS.AXP_FOOTER_E1_URL;
        }
        else if (env == Environment.Stage) {
            footerURL = APPLICATION_CONSTANTS.AXP_FOOTER_E2_URL;
        }
        else {
            footerURL = APPLICATION_CONSTANTS.AXP_FOOTER_E3_URL;
        }
        return footerURL;
    }

    HTMLPartialsDecoder = (url: any) => {
        const [html, setHTML] = useState({ __html: "" });
        useEffect(() => {
            async function createMarkup() {
                if (storage.getSession(url)) {
                    return { __html: JSON.parse(storage.getSession(url) as any) || null };
                }
                else {
                    const response = await fetch(url)
                    const backendHtmlString = await response.text();
                    return { __html: backendHtmlString };
                }
            }
            createMarkup().then(result => {
                setHTML(result);
                storage.setSession(url, JSON.stringify(result.__html))
            });
        }, []);
        return html;
    }
}